<template>
  <div class="languagePane">
    <el-select
      v-model="value"
      :placeholder="$t('login.lanuage')"
      popper-class="language-dropdown"
      @change="langChange"
    >
      <el-option
        v-for="item in options"
        :key="item.Value"
        :label="item.Key"
        :value="item.Value"
      />
    </el-select>
  </div>
</template>

<script>
import { GetLanguagePacksList, GetBaseData } from '@/axios/ICommon.js';
import { GetAllDeviceCategoryList } from '@/axios/IDevice.js';
import { alerterror, alertsuccess, warning } from '@/assets/js/common.js';

export default {
  data() {
    return {
      options: [
          {
            "Key": "Language",
            "Value": "default"
          },
          {
            "Key": "简体中文",
            "Value": "zh-cn"
          },
          {
            "Key": "English",
            "Value": "en-us"
          },
          {
            "Key": "Deutsch",
            "Value": "de"
          }
        ], //语言
      value: '', //语言版本下拉框的值
    }
  },
  mounted() {
    this.getLang();
  },
  methods: {
    /* 切换字体 */
    changeFont(theme) {
      window.document.documentElement.setAttribute("data-theme", theme)
    },
    /* 获得语言
    */
    getLang() {
      GetLanguagePacksList(this.functionGetLang);
    },
    /* 获得语言 接口返回数据处理
    * rs 接口返回数据包
    */
    functionGetLang(rs) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
       
        // this.options =[{Key: "Language",Value: "default"},...rs.Result] ;
        //todo 临时处理语言切换
        let tempList = [
          {
            "Key": "Language",
            "Value": "default"
          },
          {
            "Key": '简体中文',
            "Value": "zh-cn"
          },
          {
            "Key": "English",
            "Value": "en-us"
          },
          {
            "Key": "Deutsch",
            "Value": "de"
          }
        ]
        this.options = tempList;
        
        this.value =  getLocalStoragItem('lang') || 'Language'
      }
    },
    /* 语言切换
    */
   async langChange(e) {
      if(e !=='default'){
        this.changeFont(e);
        this.value = e;
        this.$i18n.locale = e;
        this.$store.dispatch('changeLang', e);
        this.$emit("changeLang");
        this.doGetBaseData();
        this.doGetDeviceCategoryListByClassSku();
        // this.$forceUpdate();
        // window.location.reload();
      }
      
    },
    doGetDeviceCategoryListByClassSku() {
      GetAllDeviceCategoryList(this.functionDpGetDeviceCategoryListByClassSku);
    },
    functionDpGetDeviceCategoryListByClassSku(rs) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        this.$store.dispatch('changeDeviceCategoryList', rs.Result);
      }
    },
    doGetBaseData() {
      //获取基础集合列表
      GetBaseData({ appType: 4 }, this.dunctionDoGetBaseData)
    },
    dunctionDoGetBaseData(rs) {
      if (rs.StatusCode == this.$store.state.rightStatusCode) {
        // if(_param["SystemStatusList"] instanceof Array){this.$store.dispatch('changeErrorInfor', _param["SystemStatusList"]);}
        // if(_param["DeiveStatusList"] instanceof Array){this.$store.dispatch('changeDeiveStatus', _param["DeiveStatusList"]);}
        // if(_param["EventTypeList"] instanceof Array){}
        var _param = rs.Result;
        if (_param == null) { return; }
        this.$store.dispatch('changeBaseData', _param);
        if (_param["PowerPerfix"] != null) { this.$store.dispatch('changePowerPerfix', _param["PowerPerfix"]); }
        if (_param["DeiveStatusList"] instanceof Array) { this.$store.dispatch('changeDeiveStatus', _param["DeiveStatusList"]); }
        if (_param["SystemStatusList"] instanceof Array) { this.$store.dispatch('changeErrorInfor', _param["SystemStatusList"]); }
        if (_param["DeviceTypeList"] instanceof Array) { this.$store.dispatch('changeDeviceType', _param["DeviceTypeList"]); }
        if (_param["ProtocolTypeList"] instanceof Array) { this.$store.dispatch('changeProtocolType', _param["ProtocolTypeList"]); }
        if (_param["DeviceLogLevel"] instanceof Array) { this.$store.dispatch('changeDeviceLogLevel', _param["DeviceLogLevel"]); }
        if (_param["SystemModuleList"] instanceof Array) { this.$store.dispatch('changeSystemModule', _param["SystemModuleList"]); }
        if (_param["UserActionTypeList"] instanceof Array) { this.$store.dispatch('changeUserActionType', _param["UserActionTypeList"]); }
        _param = null;
      } else {
        alerterror(this, rs.StatusCode);
      }
      this.$store.dispatch('refreshRoute');
    },
  }
}
</script>
<style>
.language-dropdown .popper__arrow{
  display: none;
}

.languagePane .el-select .el-input__inner {
  background: transparent;
  border: none;
  text-align: right;
}

.languagePane .el-input--small .el-input__icon{
  line-height: 24px;
}
</style>
